import React from 'react';
import { Content } from './shared';

const CignaPhysicalTherapy = () => (
  <Content>
    Whether you're rehabbing an injury or improving your mobility, get discounts on physical therapy
    at participating practices.
    <ol>
      <li>Visit the ChooseHealthy website and log in.</li>

      <li>Go to Physical Therapy {'>'} Find a provider.</li>

      <li>Call to set up an appointment. Don't forget your Cigna card!</li>
    </ol>
  </Content>
);

export default CignaPhysicalTherapy;
